import { render, staticRenderFns } from "./MaterialsRequest.vue?vue&type=template&id=6d52eee2&scoped=true&"
import script from "./MaterialsRequest.vue?vue&type=script&lang=js&"
export * from "./MaterialsRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52eee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d52eee2')) {
      api.createRecord('6d52eee2', component.options)
    } else {
      api.reload('6d52eee2', component.options)
    }
    module.hot.accept("./MaterialsRequest.vue?vue&type=template&id=6d52eee2&scoped=true&", function () {
      api.rerender('6d52eee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/vistas/MaterialsRequest.vue"
export default component.exports